export enum HighlightVariant {
    search = '1',
    keyword = '1',
}
export const highlight = (
    text: string,
    searchTerm: string,
    variant: HighlightVariant | undefined = HighlightVariant.search
) => {
    if (!searchTerm) {
        return text;
    }

    const normalizedText = text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    const normalizedSearchTerm = searchTerm
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    let currentIndex = 0;
    const result = [];

    while (currentIndex < normalizedText.length) {
        const index = normalizedText.indexOf(normalizedSearchTerm, currentIndex);

        if (index === -1) {
            result.push(text.substring(currentIndex));
            break;
        }

        result.push(text.substring(currentIndex, index));
        const variantClassName = `highlight-${variant}`;
        result.push(
            <span className={variantClassName} key={index}>
                {text.substring(index, index + searchTerm.length)}
            </span>
        );
        currentIndex = index + searchTerm.length;
    }

    return (
        <>
            <style>
                {`
                .highlight-1 {
                    background: rgba(0, 0, 0, 0) !important;
                    border-bottom: solid 1px #7876FB;
                }
                .highlight-2 {
                    background-color: #ffff00 !important;
                }
                .highlight-3 {
                    background: #3298FD !important;
                    color: white;
                }`}
            </style>
            {result}
        </>
    );
};
